import merge from 'lodash.merge';
import WG from './wg';

(function($, WG, ExitPopup, global) {
    var POPUP_COOKIE_NAME = 'v6_trial_exit_popup';
    var trialExitModal = $('#modal-trial-exit-popup');
    var trialExitForm = trialExitModal.find('.wg-form');
    global.isTrialExitPopupShown = false;

    $(main);

    function main() {
        if (global.isWasLoggedInWS) {
            return;
        }

        initRegistrationCookies();
        initModal();
        addListenerForInitTrialExitPopup();
        initTrialExitPopup();
        initAirPrTracking();
    }

    function expires72hours() {
        var expires72hours = new Date();
        expires72hours.setTime(expires72hours.getTime() + 72 * 60 * 60 * 1000);
        return expires72hours.toGMTString();
    }

    function initRegistrationCookies() {
        if (!WG.utils.getCookie(POPUP_COOKIE_NAME)) {
            WG.utils.setCookie(POPUP_COOKIE_NAME, 'unknown', {
                path: '/'
            });
        }
    }

    function initModal() {
        trialExitModal
            .on('show.wg.modal', function() {
                global.trackButtonEvent('interactions', 'trial_exit_popup__shown');
                global.isTrialExitPopupShown = true;
                initForm();
            })
            .on('hide.wg.modal', function() {
                var status = WG.utils.getCookie(POPUP_COOKIE_NAME);
                if (status !== 'registered' && status !== 'ignored') {
                    WG.utils.setCookie(POPUP_COOKIE_NAME, 'ignored', {
                        expires: expires72hours(),
                        path: '/'
                    });
                }
                global.trackButtonEvent('interactions', 'trial_exit_popup__closed');
            });
    }

    function initForm() {
        trialExitForm.on('submit', function() {
            if (trialExitForm.wgInstance().validateForm()) {
                WG.utils.setCookie(POPUP_COOKIE_NAME, 'registered', {
                    path: '/'
                });
            }
        });
    }

    function addListenerForInitTrialExitPopup() {
        $(document).on('gdprUserConsent', (e, options) => {
            if (options.source === 'popup') {
                initTrialExitPopup();
            }
        });
    }

    function initTrialExitPopup() {
        var status = WG.utils.getCookie(POPUP_COOKIE_NAME);

        if (status === 'muted') {
            WG.utils.setCookie(POPUP_COOKIE_NAME, 'registered', {
                path: '/'
            });
            status = 'registered';
        }

        if (status !== 'registered' && status !== 'ignored') {
            var v6TrialExitPopup = new ExitPopup();

            v6TrialExitPopup.init({
                contentSelector: '.main',
                triggerSelector: '.trial-exit-data',
                showModal: function() {
                    var hasOpenedModals = $('.wg-modal-overlay.in').length > 0;
                    var isPreventShowing = global.isExitPopupShown || hasOpenedModals;

                    if (isPreventShowing) {
                        return;
                    }

                    trialExitModal.wgInstance().show();
                }
            });
        }
    }

    function initAirPrTracking() {
        const $trialForm = $('.modal-trial-exit .wg-form');
        const $trialInput = $('.modal-trial-exit .wg-input');

        $trialForm.on('success.wg.registration', () => {
            const defaultData = {
                value: {
                    email: $trialInput.val(),
                    form: $trialForm.data('hash'),
                    registration_type: WG.utils.getRegistrationType(),
                    c_email: window.wrike.cEmail || 'null',
                    existing_user: window.wrike.isUserExisting
                }
            };

            const statSiteData = {
                group: 'trial_forms',
                event: 'trial_form__submit',
                path: window.location.pathname
            };

            const airPrData = {
                event: 'trial_form__submitted'
            };

            global.trackEventForm(merge(defaultData, statSiteData));
            new WG.AirPrTracking(merge(defaultData, airPrData));
        });

        $trialForm.on('user.exist.wg.success.registration', () => {
            const defaultData = {
                value: {
                    email: $trialInput.val(),
                    form: $trialForm.data('hash'),
                    registration_type: WG.utils.getRegistrationType(),
                    c_email: window.wrike.cEmail || 'null',
                    existing_user: window.wrike.isUserExisting
                }
            };

            const statSiteDataForExistedUser = {
                group: 'exist_user_form_submit',
                event: 'exist_trial_form__submit',
                path: window.location.pathname
            };

            const airPrDataForExistedUser = {
                event: 'exist_trial_form__submitted'
            };

            global.trackEventForm(merge(defaultData, statSiteDataForExistedUser));
            new WG.AirPrTracking(merge(defaultData, airPrDataForExistedUser));
        });
    }
})($, window.WG, ExitPopup, window.wrike);



// WEBPACK FOOTER //
// ./assets/js/common/modules/init-trial-exit-popup.js